import { render, staticRenderFns } from "./XkcdComic.vue?vue&type=template&id=0df1993a&scoped=true"
import script from "./XkcdComic.vue?vue&type=script&lang=js"
export * from "./XkcdComic.vue?vue&type=script&lang=js"
import style0 from "./XkcdComic.vue?vue&type=style&index=0&id=0df1993a&prod&scoped=true&lang=scss"
import style1 from "./XkcdComic.vue?vue&type=style&index=1&id=0df1993a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1993a",
  null
  
)

export default component.exports